onComplete(function () {
	const header = document.querySelector('header.nav-header');

	const isHome = document.querySelector("html[data-home='true']");

	const screenWidth = window.innerWidth;
	let prevScrollPos;
	let currentScrollPos = document.documentElement.scrollTop;

	window.addEventListener('scroll', function () {
		if (screenWidth > 768) {
			currentScrollPos = document.documentElement.scrollTop;
			if (prevScrollPos > currentScrollPos || prevScrollPos <= 0) {
				header.style.translate = "0 0";
			} else {
				header.style.translate = "0 -100%";
			}

			if (isHome) {
				changeNavbarBg();
			}

			prevScrollPos = currentScrollPos;
		}
	});

	const changeNavbarBg = () => {
		if (currentScrollPos > 50) {
			header.style.backgroundColor = "var(--secondary)";
		} else {
			header.style.backgroundColor = "transparent";
		}
	}
});